module.exports = __webpack_public_path__ + "static/media/login_bg.001ab4e3.svg";